import { AiOutlineTwitter, AiFillFacebook, AiFillLinkedin } from 'react-icons/ai';
import { ThreadsIcon } from '../threads';

export const socialIcons = [
    {
        id: 1,
        name: 'twitter',
        icon: <AiOutlineTwitter size={25} color='#00acee'/>
    },

    {
        id: 2,
        name: 'facebook',
        icon: <AiFillFacebook size={25} color='#3b5998'/>
    },
    {
        id: 4,
        name: 'linkedIn',
        icon: <AiFillLinkedin size={25} color='#0A66C2'/>
    },


]